

<button id="mathjax" >Add MathJax</button>
<!-- <button id="mathjax" >latex</button> -->
<!-- *ngIf="RTEFlag=='AnswerChoiceNote'||RTEFlag=='AnswerChoice'||RTEFlag=='QuestionBody'" -->

<quill-editor
 id="testquill"

  class="content-editor"
  [placeholder]="'Type here....'"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [modules]="QuillConfiguration"
  [styles]="{'min-height': '30vh'}"
  *ngIf="RTEFlag=='AnswerChoiceNote'||RTEFlag=='AnswerChoice'||RTEFlag=='QuestionBody'"
  (ngModelChange)="GetContent()"
  (onFocus)="focus($event)" 
  
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)" 
>

</quill-editor>

<!-- <quill-editor
 id="testquill"
  class="content-editor"
  [placeholder]="'Type here....'"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [modules]="QuillConfiguration"
  [styles]="{'min-height': '30vh'}"
  *ngIf="RTEFlag=='QuestionBody'"
  (ngModelChange)="GetContent()"
  (onFocus)="focus($event)" 
  
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)" 
>

</quill-editor>
<quill-editor
 id="testquill"
  class="content-editor"
  [placeholder]="'Type here....'"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [modules]="QuillConfiguration"
  [styles]="{'min-height': '30vh'}"
  *ngIf="RTEFlag=='AnswerChoice'"
  (ngModelChange)="GetContent()"
  (onFocus)="focus($event)" 
  
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)" 
>

</quill-editor>
<quill-editor
 id="testquill"
  class="content-editor"
  [placeholder]="'Type here....'"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [modules]="QuillConfiguration"
  [styles]="{'min-height': '30vh'}"
  *ngIf="RTEFlag=='AnswerChoiceNote'"
  (ngModelChange)="GetContent()"
  (onFocus)="focus($event)" 
  
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)" 
>

</quill-editor> -->


<quill-editor

  class="content-editor"
  [placeholder]="'Type here....'"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [modules]="QuillConfiguration"
  [styles]="{'height': '57vh'}"
  *ngIf="RTEFlag=='Commentbox'"
  (ngModelChange)="GetContent()"
  (onFocus)="focus($event)" 
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)"
>
<!-- <script src="script.js"></script> -->
</quill-editor>

<quill-editor

  class="content-editor"
  [placeholder]="'Type here....'"
  [modules]= "{ toolbar: false }"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [styles]="{'height': '20vh'}"
  *ngIf="RTEFlag=='Submit for review'"
  (ngModelChange)="GetContent()"
  (onFocus)="focus($event)" 
  
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)"
    
>
<!-- <script src="script.js"></script> -->
</quill-editor>

<!-- <quill-editor
  class="content-editor"
  [modules]= "{ toolbar: false }"
  [(ngModel)]="QuestionBodyget"
  (click)="getview($event)"
  [styles]="{'height': '20vh'}"
  *ngIf="RTEFlag"
  (onFocus)="focus($event)" 
  (onEditorChanged)="changedEditor($event)" 
  (onBlur)="blur($event)" 
  (onEditorCreated)="created($event)"   
>

</quill-editor> -->



<!-- <div class="row" *ngIf="value&&(RTEFlag=='AnswerChoiceNote'||RTEFlag=='AnswerChoice'||RTEFlag=='QuestionBody')" style="font-weight: 600;">
<div class="col-12 px-3">
  <div class=" d-flex">
    <div class="px-1 pt-2">
      Image Size -
    </div>
    <div class="px-1 pt-2">
    
      Height:
    </div>
    <div class="px-1 pt-1">
      <input type="number" oninput="this.value=this.value.slice(0,this.maxLength)" maxlength="4" placeholder="Px" class="form-control form-control-sm input-txt" [(ngModel)]="height"/>
    </div>
  
    <div class="px-1 pt-2">
    
      Width:
    </div>
    <div class="px-1 pt-1">
      <input type="number" oninput="this.value=this.value.slice(0,this.maxLength)" maxlength="4" placeholder="Px" class="form-control form-control-sm input-txt" [(ngModel)]="width"/>
    </div>

    <div class="px-1 pt-1">
      <button type="button" [disabled]='!height||!width' class="btn btn-sm bg-light border" (click)="changepixel()" >Resize</button>
    </div>
    
  </div>
</div>
</div> -->


<!-- <div *ngIf="value" style="font-weight: 600;">
  
      Image size - height:{{height}}px, width:{{width}}px
    
</div> -->




<!-- <button  id="button" class="e-control e-btnbtn" (click)="ViewHTML()">Get HTML</button>  -->
<!-- <div class="col-12">
    <div class="row pt-3">

      <div class="col-2 headersize">
        Question Body
      </div>
      <div class="col-10">

      </div>
      <div class="col-12">
   
        <div class="card" *ngIf="safehtmlStr!=null">
           
            <div [innerHTML]="safehtmlStr"></div>
          
        </div>
      </div>

    </div>
  </div>  -->
 <!-- <button  id="button" class="e-control e-btnbtn" (click)="getFormattedContent()">Insert HTML</button> -->
 <!-- <quill-editor
  class="content-editor"
  [placeholder]="''"
  [(ngModel)]="QuestionBodyset"
  [modules]="QuillConfiguration"
  [styles]="{'min-height': '120px'}"

  (onFocus)="focus($event)" 
    (onEditorChanged)="changedEditor($event)" 
    (onBlur)="blur($event)" 
    (onEditorCreated)="created($event)"
>
</quill-editor> -->



